import { useCallback } from 'react';
import { trackFeatureUsage } from '../utils/analytics';

const STORAGE_KEY = 'tradermap_interface_preference';

export function useInterfacePreference() {
  const getPreference = useCallback(() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }, []);

  const hasChosen = useCallback(() => {
    return getPreference() !== null;
  }, [getPreference]);

  const setPreference = useCallback((mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
      trackFeatureUsage('interface_preference_set', { mode });
    } catch (e) {
      console.error('Failed to save interface preference:', e);
    }
  }, []);

  return { getPreference, hasChosen, setPreference };
}
